
import AddProfile from '../components/profile_component/AddProfile'
import {connect} from 'react-redux'


const mapStateToProps=state=>({  
})
const mapDispatchToProps=dispatch=>({
})
export default connect(mapStateToProps,mapDispatchToProps)(AddProfile)